// import React from 'react';
// import React, { useState, useEffect } from 'react';
import header_contact from "../assets/img/header_contact.png";

import { Link } from 'react-router-dom';
import contact_feature_4 from "../assets/img/update_2/icon/contact_feature_4.svg";
import contact_feature_2 from "../assets/img/update_2/icon/contact_feature_2.svg";
import contact_feature_3 from "../assets/img/update_2/icon/contact_feature_3.svg";
import contact_feature_1 from "../assets/img/update_2/icon/contact_feature_1.svg";
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';
import Footer from './footer';
import { Helmet } from "react-helmet";

const Contactus = () => {
    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location]);
    return (
        <div>
<Helmet>
  <title>YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India</title>

  <meta
    name="description"
    content="YUMWAY is one of India's trusted frozen food brands, offering premium frozen French fries, potato wedges, burger patties, hash browns, and other preservative-free frozen snacks for domestic and global markets."
  />

  <meta
    name="keywords"
    content="YUMWAY, frozen french fries manufacturer India, frozen foods India, frozen potato products, potato wedges, hash browns, burger patties, frozen snacks, frozen food exporter India, preservative free frozen foods"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://yumwayfood.com/contactus" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    property="og:description"
    content="Discover premium frozen French fries, potato wedges, burger patties, and other frozen foods from YUMWAY. Trusted quality, natural ingredients, and global exports."
  />
  <meta property="og:url" content="https://yumwayfood.com/contactus" />
  <meta property="og:image" content="https://yumwayfood.com/og-image.png" />
  <meta property="og:site_name" content="YUMWAY" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    name="twitter:description"
    content="Premium frozen French fries, potato wedges, burger patties, and more from one of India's trusted frozen food brands."
  />
  <meta
    name="twitter:image"
    content="https://yumwayfood.com/og-image.jpg"
  />
</Helmet>            
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>
                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "-40px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 , fontFamily:'helvetica',color:"white"}}>CONTACT US</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily:'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily:'helvetica',color:'#F0B323',color: '#0f1138' }}>Contact Us</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <img
                            width="2000"
                            height=""
                            src={header_contact}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',
                                height: "",
                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />
                        </div>
                        </div>
            </div>

            <div className="space mt-4 mb-4" style={{ padding: '2rem 0' }}>
  <div className="container">
    <div className="row gy-4" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
      <div className="col-xl-3 col-sm-6" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 25%', minWidth: '200px' }}>
        <div className="contact-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <div className="contact-feature_icon">
            <img src={contact_feature_1} alt="Icon" />
          </div>
          <h4 className="box-title" style={{ fontFamily: 'helvetica',color:'#0f1138'}}>Factory Address</h4>
          <span className="contact-feature_text" style={{ fontFamily: 'helvetica' }}>
            Newryan Global Private Limited, Plot No. 74-75, AKVN, Growth Center, Malanpur, Industrial Area, Bhind-477001, Madhya Pradesh, India
          </span>
        </div>
      </div>
      <div className="col-xl-3 col-sm-6" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 25%', minWidth: '200px' }}>
        <div className="contact-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <div className="contact-feature_icon">
            <img src={contact_feature_4} alt="Icon" />
          </div>
          <h4 className="box-title" style={{ fontFamily: 'helvetica',color:'#0f1138' }}>Corporate Office</h4>
          <span className="contact-feature_text" style={{ fontFamily: 'helvetica' }}>
            C-8/2 basement and Ground floor<br />Vasant Vihar near C block <br/>Community Center New Delhi - 110057
          </span>
        </div>
      </div>
      <div className="col-xl-3 col-sm-6" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 25%', minWidth: '200px' }}>
        <div className="contact-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <div className="contact-feature_icon">
            <img src={contact_feature_2} alt="Icon" />
          </div>
          <h4 className="box-title" style={{ fontFamily: 'helvetica',color:'#0f1138'}}>Email Address</h4>
          <span className="contact-feature_text" style={{ fontFamily: 'helvetica' }}>
            <a href="mailto:support@icedreamglobal.com" style={{ fontFamily: 'helvetica' }}>support@icedreamglobal.com</a><br/><br/><br/>
          </span>
        </div>
      </div>
      <div className="col-xl-3 col-sm-6" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 25%', minWidth: '200px' }}>
        <div className="contact-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <div className="contact-feature_icon">
            <img src={contact_feature_3} alt="Icon" />
          </div>
          <h4 className="box-title" style={{ fontFamily: 'helvetica',color:'#0f1138'}}>Phone Number</h4>
          <span className="contact-feature_text" style={{ fontFamily: 'helvetica' }}>
            <a href="tel:+9999954849" style={{ fontFamily: 'helvetica' }}>(+91) 9873578910</a><br/><br/><br/>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>


            <div className="" id="mapSec">
                <div className="contact-map2">
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.0801193980747!2d72.85354431424533!3d21.02947999313118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0571ccb4b8867%3A0x7ec244669086e859!2sHN%20Indigos%20Private%20Limited!5e0!3m2!1sen!2sin!4v1626090743148!5m2!1sen!2sin" width="100%" height="200" style={{ border: '0' }} allowfullscreen="" loading="lazy"></iframe> */}
<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d5096.15147273492!2d78.28951016866098!3d26.350742136296407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDIxJzAxLjQiTiA3OMKwMTcnMjQuMCJF!5e0!3m2!1sen!2sin!4v1757678468518!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>                
                </div>
            </div>

            <section className="space-bottom contact-form-sec">
                <div className="container">
                    <div className="reservation-area">
                        <h4 className="sec-title text-center mb-30" style={{ fontFamily:'helvetica',color:'#0f1138',textTransform: 'uppercase' }}>Send Us Message</h4>
<form
  onSubmit={async (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      number: e.target.number.value,
      subject: e.target.subject.value,
      message: e.target.message.value,
    };

    try {
      const response = await fetch("https://yumwayfood.com/api.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        alert("Message sent successfully!");
        e.target.reset();
      } else {
        alert("Error sending message: " + result.error);
      }
    } catch (error) {
      alert("Something went wrong. Try again later.");
    }
  }}
  className="booking-form3 ajax-contact"
  id="sendform"
>
  <div className="row">
    <div className="form-group col-lg-4 col-md-6">
      <input type="text" className="form-control rounded-2" name="name" placeholder="Your Name" />
    </div>
    <div className="form-group col-lg-4 col-md-6">
      <input type="tel" className="form-control rounded-2" name="number" placeholder="Phone Number" />
    </div>
    <div className="form-group col-lg-4">
      <input type="text" className="form-control rounded-2" name="subject" placeholder="Subject" />
    </div>
    <div className="form-group col-12">
      <textarea name="message" cols="30" rows="3" className="form-control rounded-2" placeholder="Write Message"></textarea>
    </div>
  </div>
  <div className="text-center">
    <button type="submit" className="th-btn rounded-2" style={{ background: "#F0B323" }}>
      Send Message <i className="fa-solid fa-arrow-right ms-2"></i>
    </button>
  </div>
</form>
                    </div>
                </div>
            </section>
            <Footer />
            </div>
            );
};

export default Contactus;
